<template>
    <div>
        <v-menu
            offset-y
            min-width="auto"
            v-model="menu"
            :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    outlined
                    hide-details
                    readonly
                    append-icon="date_range"
                    v-model="displayDate"
                    :placeholder="$t('placeholder.date')"
                    :style="{
                        minWidth: '240px'
                    }"
                    v-on="on"
                    v-bind="attrs"/>
            </template>

            <v-date-picker
                no-title
                scrollable
                v-model="date"
                :color="color"/>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'DateField',

    props: {
        value: {
            type: [String, Date],
            default: null
        },

        color: {
            type: String,
            default: 'primary'
        }
    },

    data () {
        return {
            menu: false
        }
    },

    computed: {
        displayDate () {
            const date = typeof this.value === 'string' ? new Date(this.value) : this.value
            return this.$util.getDDMMYYYYDateFormat(date)
        },

        date: {
            get () {
                return ''
            },

            set (value) {
                this.$emit('input', value)
                this.menu = false
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
